import {
  closedSupportApi,
  deleteSupportFileApi,
  getListSupportApi,
  getListSupportMessageApi,
  getSupportFilesApi,
  postAddSupportFileApi,
  switchSupportApi,
  upsertSupportApi,
  upsertSupportMessageApi,
} from "helpers/backend_helper"
import {
  ADD_SUPPORT_FILE,
  CLOSED_SUPPORT,
  DELETE_SUPPORT_FILE,
  GET_LIST_SUPPORT,
  GET_LIST_SUPPORT_MESSAGE,
  GET_SUPPORT_FILES,
  SWITCH_SUPPORT,
  UPSERT_SUPPORT,
  UPSERT_SUPPORT_MESSAGE,
} from "./actionTypes"
import { takeEvery, put, call } from "redux-saga/effects"

const {
  getListSupportSuccess,
  getListSupportMessageSuccess,
  getListSupportMessageFail,
  upsertSupportFail,
  upsertSupportMessageSuccess,
  upsertSupportMessageFail,
  getListSupportFail,
  upsertSupportSuccess,
  closedSupportSuccess,
  switchSupportSuccess,
  switchSupportFail,
  closedSupportFail,
  getSupportFilesSuccess,
  getSupportFilesFail,
  addSupportFileFail,
  addSupportFileSuccess,
  deleteSupportFileSuccess,
  deleteSupportFileFail,
} = require("./actions")

function* onGetListSupport({ payload: values }) {
  try {
    const result = yield call(getListSupportApi, values)
    yield put(getListSupportSuccess(result))
  } catch (error) {
    yield put(getListSupportFail(error))
  }
}

function* onUpsertSupport({ payload: data }) {
  const { formData, params } = data

  try {
    const result = yield call(upsertSupportApi, formData)
    yield put(upsertSupportSuccess({
      message: "تیکت ایجاد شد",
      newSupport: result,
      searchParams: params
    }))
  } catch (error) {
    yield put(upsertSupportFail(error))
  }
}

function* onGetListSupportMessage({ payload: values }) {
  try {
    const result = yield call(getListSupportMessageApi, values)
    yield put(getListSupportMessageSuccess(result))
  } catch (error) {
    yield put(getListSupportMessageFail(error))
  }
}

function* onUpsertSupportMessage({ payload: data }) {
  const { updatedData, params } = data
  try {
    const result = yield call(upsertSupportMessageApi, updatedData)
    yield put(upsertSupportMessageSuccess({
      message: "پیام ارسال شد",
      newSupportMessage: result,
      searchParams: params
    }))
  } catch (error) {
    yield put(upsertSupportMessageFail(error))
  }
}

function* onClosedSupport({ payload: data }) {
  const { id } = data
  try {
    const result = yield call(closedSupportApi, id)
    yield put(closedSupportSuccess({
      id: data.id,
      updatedSupport: result
    }))
  } catch (error) {
    yield put(closedSupportFail(error))
  }
}

function* onSwitchSupport({ payload: data }) {
  try {
    const result = yield call(switchSupportApi, data)
    yield put(switchSupportSuccess({
      supportId: data.supportId,
      updatedSupport: result
    }))
  } catch (error) {
    yield put(switchSupportFail(error))
  }
}

function* onAddSupportFile({ payload: attachData }) {
  try {
    const supportId = JSON.parse(attachData.get("supportId"))
    const response = yield call(postAddSupportFileApi, attachData)
    yield put(addSupportFileSuccess(response))
    const responseFiles = yield call(getSupportFilesApi, supportId)
    yield put(getSupportFilesSuccess(responseFiles))
  } catch (error) {
    yield put(addSupportFileFail(error))
  }
}

function* onGetSupportFiles({ payload: supportId }) {
  try {
    if (supportId) {
      const response = yield call(getSupportFilesApi, supportId)

      yield put(getSupportFilesSuccess(response))
    }
  } catch (error) {
    yield put(getSupportFilesFail(error))
  }
}

function* onDeleteSupportFiles({ payload: id }) {
  try {
    yield call(deleteSupportFileApi, {id})
    yield put(deleteSupportFileSuccess({id}))
  } catch (error) {
      console.log('error',error);
    yield put(deleteSupportFileFail(error))
  }
}

function* saga() {
  yield takeEvery(DELETE_SUPPORT_FILE, onDeleteSupportFiles)
  yield takeEvery(GET_LIST_SUPPORT, onGetListSupport)
  yield takeEvery(UPSERT_SUPPORT, onUpsertSupport)
  yield takeEvery(GET_LIST_SUPPORT_MESSAGE, onGetListSupportMessage)
  yield takeEvery(UPSERT_SUPPORT_MESSAGE, onUpsertSupportMessage)
  yield takeEvery(CLOSED_SUPPORT, onClosedSupport)
  yield takeEvery(SWITCH_SUPPORT, onSwitchSupport)
  yield takeEvery(ADD_SUPPORT_FILE, onAddSupportFile)
  yield takeEvery(GET_SUPPORT_FILES, onGetSupportFiles)
}

export default saga
